import styled from 'styled-components'

import { HeaderRow as DefaultHeaderRow } from 'components/Lists'

export const HeaderRow = styled(DefaultHeaderRow)`
	font-size: 16px;
	padding: 16px;
	column-gap: 9px;
`
